<template>
  <div class="add-area-form">
    <el-dialog
      title="房源上线配置"
      :close-on-click-modal="false"
      @close="close"
      :before-close="close"
      visible
    >
      <el-form
        inline
        ref="formData"
        :rules="rules"
        :model="formData"
        label-width="110px"
        label-position="right"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="新增社区/小区" class="half-line">
              <el-input @change="blockChange" placeholder="请输入社区/小区" v-model="formData.blockName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="新增所属公司" class="half-line">
              <el-input placeholder="请输入所属公司" v-model="formData.companyName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="this.show">
          <el-col :span="12">
            <el-form-item label="地区" class="half-line" prop="zoneCheck">
              <el-cascader
                :options="options"
                v-model="selectedOptions"
                @change="areaChange"
                placeholder="地区"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="add-house" @click="this.close">取消</el-button>
        <el-button type="primary" :loading="isLoading" @click="sure('formData')">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import centralApi from '@/xhr/services/central'
import options from './country-data.js'

export default {
  data() {
    var zoneCheck = (rule, value, callback) => {
      let name = this.selectedOptions
      if (!name || name.length < 1) {
        callback('请选择地区')
      } else {
        callback()
      }
    }

    return {
      // houseTypeEum,
      formData: {
        blockName: '',
        district: '',
        city: '',
        province: '',
        companyName: '',
      },
      show: '',
      selectedOptions: [], // 存放默认值
      options: options, // 存放城市数据
      isLoading: false,
      rules: {
        zoneCheck: [{ required: true, validator: zoneCheck }],
      },
    }
  },
  watch: {},
  created() {},
  computed: {},
  methods: {
    close() {
      this.$emit('closeHouseRes')
    },
    //  输入小区
    blockChange(val) {
      if (val !== '') {
        this.show = true
      } else {
        this.show = false
      }
    },
    // 选择地区
    areaChange(val) {
      this.formData.name = val
    },

    // 二次确认提交弹框
    sure(val) {
      this.$refs[val].validate((valid) => {
        if (valid) {
          this.isLoading = true
          let params = {
            blockName: this.formData.blockName,
            district: this.selectedOptions[2],
            city: this.selectedOptions[1],
            province: this.selectedOptions[0],
            companyName: this.formData.companyName,
          }
          if (this.formData.blockName !== '' || this.formData.companyName !== '') {
              centralApi.HouseResConfig(params).then((res) => {
                if (res.data.code === 200) {
                  this.$message.success('房源上线配置添加成功')
                  this.close()
                } else {
                  this.$message.warning(`房源上线配置添加失败, 原因:${res.data.message}`)
                  this.isLoading = false
                }
              })
           } else {
             this.$message.error('请输入社区或所属公司！')
             this.isLoading = false
           }
        }
      })
    },
  },
  filters: {
    // dealWithBlank, // 去除字符串两端空格
  },
}
</script>
<style lang="scss" scoped>
.house-withdraw-form {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #333333;
  position: relative;
  .all-line {
    width: 100%;
    .inline-input {
      width: 100%;
    }
  }
  .title-alert {
    position: relative;
    font-size: 14px;
    color: red;
    font-weight: bold;
    top: -52px;
    left: 80px;
  }
  .delete-button {
    position: relative;
    top: 4px;
    left: 5px;
  }
  .add-house {
    position: absolute;
    left: 20px;
  }
}
</style>
<style>
/* 修改 element-ui 样式 */
.house-withdraw-form .all-line .el-form-item__content {
  width: 77.5%;
}
.house-withdraw-form .all-line .el-form-item__content .el-cascader {
  width: 100%;
}
.house-withdraw-form .el-input__icon + .el-input__inner {
  padding-right: 10px;
}
.house-withdraw-form .el-dialog {
  width: 665px !important;
}
.house-withdraw-form .el-dialog__title {
  font-size: 18px;
  font-weight: bold;
}
/* 红色按钮样式 */
.house-withdraw-form .delete-button:active {
  color: #fff;
  border-color: #e64242;
}
.house-withdraw-form .delete-button:hover {
  color: #ff6d6d;
  border-color: #ff6d6d;
  color: #fff;
}
.house-withdraw-form .delete-button:focus {
  background: #ff6d6d;
  border-color: #ff6d6d;
  color: #fff;
}
</style>
<style lang="scss">
.house-withdraw-form {
  .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 110px;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/forms/HouseResConfig/index.vue